import BootstrapField from '../utility/BootstrapField';
import IsEqual from 'lodash.isequal';
// import CloneDeep from 'lodash.clonedeep';
// import DeepDiff from 'deep-diff';
import LaneClosureRequestMessage from '../models/LaneClosureRequestMessage';

import LaneClosureRequest from '../models/LaneClosureRequest';
import LaneClosure from '../models/LaneClosure';
import Restriction from '../models/Restriction';
import Attachment from '../models/Attachment';

// As private as it gets.
let originalContraventionData = null;

export default class Contravention {

	static get getContraventionTypeIdOptions() {
		return [
			{
				id: 1,
				name: "No Request Submitted"
			},
			{
				id: 2,
				name: "Existing Request Infraction"
			},
			{
				id: 3,
				name: "Existing Report Infraction"
			}
		];
	}

	static get getFilterByLaneClosureRequestOptions() {
		return [
			{
				id: 1,
				name: "Expired, Needs Violation"
			},
			{
				id: 2,
				name: "With Violation"
			},
			{
				id: 3,
				name: "Without Violation"
			},
		];
	}

	static getContraventionTypeIdText(id) {
		if (id) {
			return this.searchById(id, this.getContraventionTypeIdOptions).name;
		}
		return null;
	}


	static searchById(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].id === nameKey) {
				return iArray[i]
			}
		}
	}



	constructor(data) {
		if (!data) {
			data = {};
		}
		if (data.useTestData) {
			data = {
				officer: {
					altPhone: null,
					email: "lc_officer@patterninteractive.com",
					firstName: "Alex",
					isActive: 1,
					isAway: 0,
					lastName: "Murphy",
					organizationId: 4,
					organizationName: "Traffic Management Branch",
					phone: "204-555-3444",
					title: "Enforcement Officer",
					userId: 3
				},
				officerId: 21,
			}
		}

		Object.assign(this, {
			id: data.id || null,
			officerId: data.officerId || null,
			typeId: new BootstrapField({
				value: data.typeId || null
			}),
			lcrId: data.lcrId || null,
			createdUserId: data.createdUserId || null,
			createdDate: data.createdDate || null,
			modifiedDate: data.modifiedDate || null,
			comments: new BootstrapField({
				value: data.comments || null,
			}),

			officer: data.officer || null,
			block: data.block || [],
			attachment: [],
			message: [],
			laneClosureRequest: null,
			laneClosure: null,
			restriction: null,
			createdBy: data.createdBy || null,
		});
		if (data.laneClosureRequest != null) {
			this.laneClosureRequest = new LaneClosureRequest(data.laneClosureRequest);
		}
		if (data.laneClosure != null) {
			this.laneClosure = new LaneClosure(data.laneClosure);
		}
		if (data.restriction != null) {
			this.restriction = new Restriction(data.restriction);
		}
		if (data.message instanceof Array) {
			let x = 0;
			for (x = 0; x < data.message.length; x++) {
				this.message.push(new LaneClosureRequestMessage(data.message[x]));
			}
		}
		if (data.attachment instanceof Array) {
			let x = 0;
			for (x = 0; x < data.attachment.length; x++) {
				this.attachment.push(new Attachment(data.attachment[x]));
			}
		}

		// Keep a record of the old data. (used for the hasChanges() method)
		originalContraventionData = this.getRawValue();

	}

	validate() {

		this.toTime.invalidMessage = 'Please enter a valid end time';
		this.toDate.invalidMessage = 'Please enter a valid estimated completion date';
		let flag = true;

		let errors = [];


		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getRawValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {
		return !IsEqual(originalContraventionData, this.getRawValue());
	}
	revertChanges() {
		this.constructor(originalContraventionData);
	}
	saveChanges() {
		// originalContraventionData = CloneDeep(this);
		originalContraventionData = this.getRawValue();
	}
}